// src/components/Services/ServiceCard.tsx
import React from "react";

type Props = {
    title: string;
    description: string;
    icon?: React.ReactNode; // optional icon if you want to pass one
};

const ServiceCard: React.FC<Props> = ({ title, description, icon }) => {
    return (
        <div className="rounded-xl bg-white shadow-md hover:shadow-lg transition p-6 text-left">
            {icon && <div className="mb-4 text-blue-600 h-12 w-12">{icon}</div>}
            <h3 className="text-lg font-bold text-gray-900">{title}</h3>
            <p className="mt-2 text-gray-600 text-sm">{description}</p>
        </div>
    );
};

export default ServiceCard;
